import { useEffect, useState } from "react";

const NAV_LINKS = [
  { key: "hot", label: "今日热榜", icon: "ri-fire-line" },
  { key: "timeline", label: "时间线复盘", icon: "ri-time-line" },
  { key: "review", label: "深度复盘", icon: "ri-quill-pen-line" },
  { key: "channels", label: "栏目分类", icon: "ri-layout-grid-line" },
  { key: "faq", label: "常见问题", icon: "ri-question-line" },
];

export default function TopNav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goTo = (key: string) => {
    document.getElementById(key)?.scrollIntoView({ behavior: "smooth", block: "start" });
    setOpen(false);
  };

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-all duration-300 ${
        scrolled ? "bg-background-50/95 shadow-sm backdrop-blur border-b border-background-200/70" : "bg-background-50"
      }`}
    >
      <nav className="mx-auto w-full max-w-[1200px] px-4 md:px-6" aria-label="主导航">
        <div className="flex h-16 items-center justify-between">
          <button onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} className="flex items-center gap-2.5 cursor-pointer" aria-label="回到首页">
            <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50 text-lg">
              <i className="ri-water-flash-line"></i>
            </span>
            <span className="font-heading text-xl font-bold tracking-wide text-foreground-950">
              今日看<span className="text-primary-600">瓜</span>
            </span>
          </button>

          <div className="hidden items-center gap-1 lg:flex">
            {NAV_LINKS.map((l) => (
              <button
                key={l.key}
                onClick={() => goTo(l.key)}
                className="cursor-pointer rounded-full px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-primary-100 hover:text-primary-700 whitespace-nowrap"
              >
                {l.label}
              </button>
            ))}
          </div>

          <div className="hidden items-center gap-2 lg:flex">
            <button
              onClick={() => goTo("subscribe")}
              className="whitespace-nowrap cursor-pointer inline-flex items-center gap-2 rounded-full bg-primary-500 px-5 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-notification-3-line"></i>订阅热榜
            </button>
          </div>

          <button
            className="flex h-10 w-10 items-center justify-center rounded-lg text-foreground-800 lg:hidden cursor-pointer"
            onClick={() => setOpen((v) => !v)}
            aria-label="打开菜单"
          >
            <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-2xl`}></i>
          </button>
        </div>

        {open && (
          <div className="border-t border-background-200/70 py-3 lg:hidden">
            <div className="flex flex-col gap-1">
              {NAV_LINKS.map((l) => (
                <button
                  key={l.key}
                  onClick={() => goTo(l.key)}
                  className="flex items-center gap-3 rounded-lg px-4 py-3 text-left text-sm font-medium text-foreground-800 hover:bg-primary-100 hover:text-primary-700 cursor-pointer"
                >
                  <i className={`${l.icon} text-base text-primary-500`}></i>
                  {l.label}
                </button>
              ))}
              <button
                onClick={() => goTo("subscribe")}
                className="mt-2 inline-flex items-center justify-center gap-2 rounded-full bg-primary-500 px-4 py-3 text-sm font-medium text-background-50 cursor-pointer"
              >
                <i className="ri-notification-3-line"></i>订阅热榜
              </button>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}